import { render } from "./About.vue?vue&type=template&id=29520b0e&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=29520b0e&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-29520b0e"

export default script